import { useMap } from 'ahooks';
import constate from 'constate';
import { useEffect } from 'react';

export interface RuleItemConfig {
  id: string;
  rule: unknown;
}

export interface RuleListProviderProps {
  rules: RuleItemConfig[];
  openedRules: RuleItemConfig['id'][];

  onOpenRule?: (id: RuleItemConfig['id']) => void;
  onCloseRule?: (id: RuleItemConfig['id']) => void;
}

const useRuleListProvider = ({
  rules,
  openedRules,
  onOpenRule,
  onCloseRule,
}: RuleListProviderProps) => {
  const [, { get, setAll }] = useMap<string, boolean>();

  useEffect(() => {
    setAll(rules.map(({ id }) => [id, openedRules.includes(id)]));
  }, [openedRules, rules, setAll]);

  return {
    isRuleItemOpen: (id: string) => get(id),
    onOpenRule,
    onCloseRule,
  };
};

export const [RuleListProvider, useRuleList] = constate(useRuleListProvider);
